import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursos } from '../../app/models/CATCursos';
import { Botonera } from '../Portafolio/helpers/botonera';
import { useStore } from "../../app/stores/store";

import { AnchorTabsCursos } from "../Portafolio/Handlers/AnchorTabs";
import { BuscadorComponent } from "../Portafolio/BuscadorCursos/BuscadorComponent";
import { calculoFechas } from "../Portafolio/helpers/calculoFechas";

import banner from "../../images/cursos_diplomados.jpg";
import Footer from "../Footer";

import icon_person from '../Portafolio/src/imgs/person_icon.svg';
import icon_teacher from '../Portafolio/src/imgs/teacher_icon.svg';
import icon_calendar from '../Portafolio/src/imgs/calendar_icon.svg';
import { RegionalBannerPeten } from '../Portafolio/Handlers/RegionalBannerPeten';
import { AnchorTabsCategories } from "../Portafolio/Handlers/AnchorTabsCategories";

export default observer(function Cursos() {

  const { userStore: { user, logout, isLoggedIn } } = useStore();
  const { CATCursosStore } = useStore();
  const { loadCATCursosByDir, CATCursosRegistry, getCATCursosByCodigo, loadCATCursosByLevel } = CATCursosStore;

  useEffect(() => {
    if (CATCursosRegistry.size <= 1) {
      loadCATCursosByLevel("144", "2");
      loadCATCursosByLevel("155", "2");
      loadCATCursosByLevel("166", "2");
    }
  }, [CATCursosRegistry.size, loadCATCursosByLevel]);

  if (CATCursosStore.loadingInitial)

    return <LoadingComponent content="Cargando datos.." />;
  return (
    <>

      <RegionalBannerPeten/>
      <AnchorTabsCategories />

      {/* <div className="banner_area container-fluid">
        <div className="banner_top">
          <img src={banner}></img>
        </div>
      </div> */}

      < AnchorTabsCursos />

      <div className="portafolio_phome_area catalogo_servicios">

        <div className="portafolio_header">
        <Botonera/>
          <div className="buscador_area">
            <BuscadorComponent />
          </div>
        </div>

        <div id="hw_search" className="portafolio_htexto">
          <p>
            Desarrollar competencias en los participantes para atender las necesidades relativas a la gestión por resultados, involucrando el desarrollo de la capacidad de análisis, el uso de la información para la toma de decisiones dentro de un sistema de gestión establecido que responda al manejo de las metodologías e instrumentos de presupuestos por resultados.
          </p>
        </div>

        <div id="section1" className="portafolio_subcat first_section">
          <h2>Cursos MOOC</h2>
        </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {
            
            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "144" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_basica">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>

        <div id="section2" className="portafolio_subcat second_section">
          <h2>Cursos en línea</h2>
        </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "155" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_intermedia">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>


        <div id="section3" className="portafolio_subcat second_section">
          <h2>Diplomados</h2>
        </div>

        <div id="hw_search" className="portafolio_content">

          {CATCursosStore.getCATCursosByLevel.map((item: getCATCursos) => {

            const url = `/asesoria/${item.id}/${user?.id}`,
                  startDateFrom = new Date( item.editions[0]?.fechaDeInicioInscripcion );

            if (
              item.nivel == "166" && item.editions[0]?.is_active === true
            ) {
              return (

                <>

                  <div className="portafolio_card">

                    <Link to={url}>

                      <div className="pcard_imagen"> <img src={item.imageUrl} alt={item.nombre} /></div>
                      <div className="pcard_tipoc"> <p className="mod_card_avanzada">{item.modalidad}</p></div>

                      <div className="pcard_contenido_publico">
                        <div className="pcard_edicion">
                          <p>-Edición en curso {item.editions[0]?.numeroEdicion}</p>
                        </div>

                        <div className="pcard_titulo_curso">
                          <p className='titulo_curso' id='titulo_curso'>{item.nombre}</p>
                        </div>

                        <div className="card_info_curso">
                          <div className="pcard_estudiantes">
                            <img src={icon_person} />
                            <p>Inicio de inscripciones</p>
                          </div>
                          <div className="pcard_fecha">
                            <img src={icon_calendar} />
                            <p> {calculoFechas( startDateFrom )} </p>
                          </div>
                        </div>

                        <div className="pcard_docentes">
                          <img src={icon_teacher} />
                          <p>Lic. {item.editions[0]?.catedratico}</p>
                        </div>

                      </div>

                      <div className="pcard_linea"><span></span></div>

                    </Link>

                  </div>

                </>


              );
            }
          })}

        </div>

      </div>

      <Footer />

    </>

  );
});
